/**
 * file-download.js
 * ファイルダウンロード用クラス
 */

// ファイルダウンロード用ライブラリ
import { saveAs } from "file-saver"
// エンコード用ライブラリ
import { convert, stringToCode } from "encoding-japanese"

export default {
    /**
     * ファイルダウンロード
     * @param {*} res APIレスポンス
     */
    fileDownload (res) {
        let fileName = ''
        // レスポンスヘッダからファイル名を取得する
        const disposition = res.headers['content-disposition']
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        const matches = filenameRegex.exec(disposition)
        if (matches != null && matches[1]) {
            // ファイル名を括っているクォーテーションを削除
            fileName = decodeURI(matches[1].replace(/['"]/g, ''))
        }
        // データそのものはUTF-8なので、CP932(Shift-JIS)に変換する
        const unicodeList = stringToCode(res.data)
        const sjisCodeList = convert(unicodeList, "CP932")
        const sjisData = new Uint8Array(sjisCodeList)

        // ダウンロードデータをBlobに変換
        const blob = new Blob([sjisData], {
            type: res.headers['content-type']
        })

        // ダウンロード
        saveAs(blob, fileName)
    }
}



// WEBPACK FOOTER //
// ./src/hrm-frontend/modules/functions/file-download.js